export default "/images/vendor/flag-icon-css/flags/1x1/lt.svg?1d07a8b84f27401d15e2578801e366a5";